import React, { Fragment, useCallback } from "react";
import { useAPI } from "components/lib";
import { StylesManager, Model } from "survey-core";
import { Survey } from "survey-react-ui";
import Axios from "axios";
import "survey-core/defaultV2.min.css";
import { applyStackgoTheme } from "components/survey/stackgo-theme";

StylesManager.applyTheme("defaultV2");

export function ClioSettingsView(props) {
  const existingSettingsResponse = useAPI("/api/integration/clio/settings");
  const env = process.env.NODE_ENV;
  const navigateToUrl =
    env === "production"
      ? `https://identity.stackgo.io/account`
      : `http://localhost:3000/account`;

  function setExistingClioSettings() {
    if (
      existingSettingsResponse.loading === false &&
      existingSettingsResponse.data !== null
    ) {
      const settings = existingSettingsResponse?.data?.[0];
      survey.setValue("enabled", settings?.enabled);
    }
  }

  const json = {
    completedHtml: "<h3>Your changes have been saved.</h3>",
    showQuestionNumbers: "off",
    pages: [
      {
        name: "ClioSettingsView",
        elements: [
          {
            type: "boolean",
            name: "enabled",
            title: "Enabled",
            isRequired: true,
            defaultValue: false,
          },
          {
            type: "html",
            name: "info",
            html: `<p>Clio integration allows you to manage client verification processes directly within your Clio practice management system.</p>
            <p>To use this integration, you must first install and connect your Clio account using the Install button on the integrations page.</p>
            `,
          },
        ],
      },
    ],
  };

  json.navigateToUrl = navigateToUrl;

  async function saveSurveyResults(url, json) {
    console.log("saveSettings", url, json);
    const response = await Axios.post(url, json);
  }

  const clioSettingsAdded = useCallback((sender) => {
    saveSurveyResults("/api/integration/clio/settings", sender.data);
  });

  const survey = new Model(json);
  applyStackgoTheme(survey);
  survey.onComplete.add(clioSettingsAdded);
  setExistingClioSettings();

  return (
    <Fragment>
      <Survey model={survey} />
    </Fragment>
  );
}